import React from 'react'
import * as Styled from './CountBadge.styles'

const CountBadge = ({ items = 0, isFlag = true, maxDisplay = 6, type = 'offers' }) => {
  const numberOfOnDisplay = Math.min(items, maxDisplay)

  if (!items) return null

  return (
    <Styled.Badge isFlag={isFlag} type={type}>
      <span>
        <strong>{numberOfOnDisplay}</strong>
      </span>
    </Styled.Badge>
  )
}

export default CountBadge
